import { readTabContext, writeTabContext, clearTabContext } from '@/services/auth/partnerSessionStorage';
import { deleteRecord, getSyncState, saveSyncState } from '@/services/localDb';

export const OFFLINE_SESSION_STATE_KEY = 'app_state:offline_session';
export const RESTAURANT_CUSTOMS_STATE_KEY = 'app_state:restaurant_customs';
export const WAITER_MODE_STATE_KEY = 'app_state:is_waiter_mode';

export async function getPersistedAppState(key) {
  if (!key) return null;
  if (key === WAITER_MODE_STATE_KEY || key === OFFLINE_SESSION_STATE_KEY || key === RESTAURANT_CUSTOMS_STATE_KEY) {
    const value = readTabContext(key);
    return value ? JSON.parse(value) : null;
  }
  return getSyncState(key);
}

export async function setPersistedAppState(key, value) {
  if (!key) return null;
  if (key === WAITER_MODE_STATE_KEY || key === OFFLINE_SESSION_STATE_KEY || key === RESTAURANT_CUSTOMS_STATE_KEY) {
    writeTabContext(key, JSON.stringify(value));
    return value;
  }
  return saveSyncState(key, value);
}

export async function removePersistedAppState(key) {
  if (!key) return false;
  if (key === WAITER_MODE_STATE_KEY || key === OFFLINE_SESSION_STATE_KEY || key === RESTAURANT_CUSTOMS_STATE_KEY) {
    clearTabContext(key);
    return true;
  }
  return deleteRecord('sync_state', key);
}
